export const CURRENT_LOCATION = "➤ Current Location";

export const WINE_BRANDS = [
  "Barefoot",
  "Yellowtail",
  "Apothic",
  "Cupcake",
  "Josh",
  "14Hands",
  "Conundrum",
  "Rombauer",
  "LaMarca",
  "Cupcake",
  "Menage",
  "Bogle",
  "Parducci",
  "DarkHorse",
  "Ménage",
  "Gnarly",
  "Gallo",
  "Rex",
  "Wente",
  "Rodney",
  "Chateau",
  "Simmer",
  "Coppola",
  "Columbia",
  "Folie",
  "Beringer",
  "Sutter",
  "Firestone",
  "Seghesio",
  "Charles",
  "Louis",
  "Schramsberg",
  "Kendall",
  "Bliss",
  "Vineyard",
  "Mondavi",
  "Lindemans",
  "Cloudy",
  "Trimbach",
  "Duckhorn",
  "Vina",
  "Alamos",
  "Mirassou",
  "Diora",
  "Layer",
  "JLohr",
  "Mionetto",
  "Giesen",
  "Fetzer",
  "Vino",
  "Corbett",
  "Vigna",
  "Pio",
  "Tarantino",
  "DeLoach",
  "Tawny",
  "Tasca",
  "Cheval",
  "Costa",
  "Marques",
  "Campo",
  "Solstice",
  "Aquinas",
  "Caymus",
  "Taittinger",
  "Carpineto",
  "Pinnacle",
  "Rockwall",
  "Blackstone",
  "Frescobaldi",
  "Guigal",
  "Ravenswood",
  "Cline",
  "Brancott",
  "Cayuga",
  "Saint",
  "Chardonnay",
  "Moscato",
  "Valpolicella",
  "Barossa",
  "Steele",
  "Vignobles",
  "Torre",
  "Vega",
  "Frescobaldi",
  "Brewery",
  "Cava",
  "Vasilis",
  "Carmignano",
  "Granbazán",
  "Domaine",
  "Mendoza",
  "Montalcino",
  "Barossa",
  "Lodi",
  "Saint-Émilion",
  "Bordeaux",
  "Sangiovese",
  "Montepulciano",
  "Valle",
  "Langhe",
  "Sauvignon",
  "Bourgogne",
  "Murray",
  "Oregon",
  "Pommard",
  "Tuscany",
  "Pinot",
  "Gavi",
  "Domaine",
  "ViuManent",
  "Vidal",
  "Sangiovese",
  "Fresita",
  "Sommelier",
];

export const WINE_ADJECTIVES = [
  "Dry",
  "Sweet",
  "Fruity",
  "Oaky",
  "Buttery",
  "Crisp",
  "Smooth",
  "Rich",
  "Bold",
  "Tannic",
  "Velvety",
  "Elegant",
  "Full-bodied",
  "Light",
  "Zesty",
  "Floral",
  "Spicy",
  "Citrusy",
  "Earthy",
  "Herbaceous",
  "Woody",
  "Creamy",
  "Lush",
  "Complex",
  "Intense",
  "Savory",
  "Lively",
  "Fresh",
  "Clean",
  "Tart",
  "Jammy",
  "Mellow",
  "Vibrant",
  "Silky",
  "Bright",
  "Sour",
  "Round",
  "Sharp",
  "Supple",
  "Plush",
  "Tense",
  "Tangy",
  "Balanced",
  "Hearty",
  "Generous",
  "Mineral",
  "Rich",
  "Opulent",
  "Savory",
  "Mature",
  "Smooth",
  "Finesse",
  "Ripe",
  "Steely",
  "Refined",
  "Fruity",
  "Dry",
  "Vibrant",
  "Grippy",
  "Zingy",
  "Peppery",
  "Bitter",
  "Gamy",
  "Soft",
  "Silky",
  "Piquant",
  "Bold",
  "Tart",
  "Warm",
  "Spicy",
  "Harmonious",
  "Peachy",
  "Cherry-like",
  "Chocolatey",
  "Nutty",
  "Fizzy",
  "Nutty",
  "Minerally",
  "Delicate",
  "Exotic",
  "Lush",
  "Bitter",
  "Funky",
  "Pungent",
  "Concentrated",
  "Sweetish",
  "Silken",
  "Lean",
  "Tasty",
  "Petite",
  "Chewy",
  "Layered",
  "Zesty",
  "Mouthwatering",
  "Mellow",
  "Tingling",
  "Subtle",
  "Smoky",
  "Sleek",
  "Juicy",
  "Herbal",
  "Tangy",
  "Silken",
  "Rustic",
  "Lively",
  "Piquant",
  "Fine",
  "Supple",
  "Fresh",
  "Structured",
  "Crisp",
  "Pleasant",
  "Deep",
  "Rich",
  "Sturdy",
  "Exquisite",
];
